<div [formGroup]="TerminalFormGroup">

  <div>
    <br />
    <b style="color: #477c93;"> Terminal details</b>
    <div class="-divider dropdown-divider" style="border: 1px solid #348cd4"></div>
    <br />
  </div>

  <div class="row form-horizontal">
    <div class="col-md-6 form-horizontal px-3">

      <div class="form-group row">
        <label for="terminalId" class="col-4 col-form-label">Terminal Id</label>
        <div class="col-8">
          <input formControlName="terminalId" class="form-control" id="terminalId" minlength="8" maxlength="8" pattern="[a-zA-Z0-9]+" placeholder="Terminal Id" />
          <ul *ngIf="submitted ||this.TerminalFormGroup.controls['terminalId'].dirty || this.TerminalFormGroup.controls['terminalId'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['terminalId'].hasError('required')" class="parsley-required">Terminal Id must be atleast 8 characters.</li>
            <li *ngIf="TerminalFormGroup.controls['terminalId'].hasError('minlength')" class="parsley-error">Terminal Id must be atleast 8 characters.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="terminalNumber" class="col-4 col-form-label">Terminal Number</label>
        <div class="col-8">
          <input formControlName="terminalNumber" class="form-control" id="terminalNumber" minlength="1" maxlength="4" placeholder="Terminal Number" />
          <ul *ngIf="submitted ||this.TerminalFormGroup.controls['terminalNumber'].dirty || this.TerminalFormGroup.controls['terminalId'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['terminalNumber'].hasError('required')" class="parsley-required">Terminal number is required</li>
            <li *ngIf="TerminalFormGroup.controls['terminalNumber'].hasError('minlength')" class="parsley-error">Terminal number must be less than 5 characters.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="terminalType" class="col-4 col-form-label">Device Ownership</label>
        <div class="col-8">
          <ng-select2 id="deviceOwnership" formControlName="deviceOwnership" [data]="deviceOwnershipTypes" [options]="select2options" [placeholder]="'Please select a type'"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['deviceOwnership'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['deviceOwnership'].hasError('required')" class="parsley-required">Type is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="terminalType" class="col-4 col-form-label">Terminal Type</label>
        <div class="col-8">
          <ng-select2 id="terminalType" formControlName="terminalType" [data]="termTypes" [options]="select2options" [placeholder]="'Please select a terminal type'"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['terminalType'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['terminalType'].hasError('required')" class="parsley-required">Terminal make is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="productProfile" class="col-4 col-form-label">Product profile</label>
        <div class="col-8">
          <ng-select2 id="productProfile" formControlName="productProfile" [data]="proList" [options]="select2options" [placeholder]="'Please select a product profile'"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['productProfile'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['productProfile'].hasError('required')" class="parsley-required">Terminal make is required.</li>
          </ul>
        </div>
      </div>
      <div class="form-group row">
        <label for="terminalCapabilities" class="col-4 col-form-label">Terminal capability</label>
        <div class="col-8">
          <ng-select2 id="terminalCapabilities" formControlName="terminalCapabilities" [data]="capList" [options]="select2options" [placeholder]="'Please select a terminal capability'"></ng-select2>
          <ul *ngIf="submitted ||this.TerminalFormGroup.controls['terminalCapabilities'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['terminalCapabilities'].hasError('required')" class="parsley-required">Terminal make is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="commsProfile" class="col-4 col-form-label">Comms profile</label>
        <div class="col-8">
          <ng-select2 id="commsProfile" formControlName="commsProfile" [data]="comList" [options]="select2options" [placeholder]="'Please select a comms profile'"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['commsProfile'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['commsProfile'].hasError('required')" class="parsley-required">Terminal make is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label">Make</label>
        <div class="col-8">
          <ng-select2 id="deviceMake" formControlName="deviceMake" [data]="deviceMakeList" [options]="select2options" [placeholder]="'Please select a make...'" (valueChanged)="onMakeChange($event)"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['deviceMake'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['deviceMake'].hasError('required')" class="parsley-required">Terminal make is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label">Model</label>
        <div class="col-8">
          <ng-select2 formControlName="deviceModel" [data]="deviceModels" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['deviceModel'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['deviceModel'].hasError('required')" class="parsley-required">Terminal model is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label">Retail</label>
        <div class="col-8">
          <ng-multiselect-dropdown [settings]="dropdownSettings"
                                   [data]="retailDropdownList"
                                   formControlName="retail"
                                   (onSelect)="onItemSelect($event)"
                                   (onSelectAll)="onSelectAll($event)"
                                   (onDeSelect)="onItemDeSelect($event)"
                                   (onDeSelectAll)="onUnSelectAll()">
          </ng-multiselect-dropdown>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label">Admin</label>
        <div class="col-8">
          <ng-multiselect-dropdown [settings]="dropdownSettings"
                                   [data]="adminDropdownList"
                                   formControlName="admin"
                                   (onSelect)="onItemSelect($event)"
                                   (onSelectAll)="onSelectAll($event)"
                                   (onDeSelect)="onItemDeSelect($event)"
                                   (onDeSelectAll)="onUnSelectAll()">
          </ng-multiselect-dropdown>
        </div>
      </div>

      <div class="form-group row" *ngIf="displayContent">
        <label class="col-4 col-form-label">Banking window</label>
        <div class="col-8">
          <ng-select2 id="ctrlBankingWindow" formControlName="bankingWindowTime" [data]="terminalInteractionBankingWindowTimes" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['bankingWindowTime'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['bankingWindowTime'].hasError('required')" class="parsley-required">Banking window is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row" *ngIf="displayContent">
        <label class="col-4 col-form-label">Parameter download day</label>
        <div class="col-8">
          <ng-select2 id="parameterDownloadDay" formControlName="parameterDownloadDay" [data]="parameterDownloadInteractionDays" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['parameterDownloadDay'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['parameterDownloadDay'].hasError('required')" class="parsley-required">Parameter download day is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row" *ngIf="displayContent">
        <label class="col-4 col-form-label">Parameter download window</label>
        <div class="col-8">
          <ng-select2 id="parameterDownloadWindowTime" formControlName="parameterDownloadWindowTime" [data]="terminalInteractionParameterTimes" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['parameterDownloadWindowTime'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['parameterDownloadWindowTime'].hasError('required')" class="parsley-required">Parameter download window is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row" *ngIf="displayContent">
        <label class="col-4 col-form-label"></label>
        <div class="col-8">
          <input formControlName="isContactless" style="display:inline;width: 10%;" type="checkbox" id="isContactless" placeholder="Contactless" /> <b>Contactless </b>
          <br />
          <input formControlName="isTerminalActive" style="display:inline;width: 10%;" type="checkbox" id="term_active" placeholder="isTerminalActive" />  <b>Activate terminal</b>
        </div>
      </div>

      <div class="form-group row">
        <label for="terminaldelivery" class="col-4 col-form-label">Terminal(s) delivery method?</label>
        <div class="col-8">
          <ng-select2 id="terminaldelivery" formControlName="terminaldelivery" [data]="terminalDeliveryMethod" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted ||this.TerminalFormGroup.controls['terminaldelivery'].dirty || this.TerminalFormGroup.controls['terminaldelivery'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['terminaldelivery'].hasError('required')" class="parsley-required">Please select terminal delivery method.</li>
          </ul>
        </div>
      </div>

    </div>

    <div class="col-md-6 form-horizontal px-3">

      <div class="form-group row" style="">
        <div class="col-12">
          <input formControlName="sameAsMerchantAddress" style="display:inline; width:10%;" type="checkbox" id="sameAsMerchantAddress" placeholder="Delivery address same as Merchant address" (ngModelChange)="setDeliveryAddress($event)" />  <b>Delivery address same as Merchant address</b>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label">Delivery address</label>
        <div class="col-8">
          <textarea rows="4" cols="24" formControlName="address" class="form-control" id="address" placeholder="Delivery address if not the same as Merchant's site address"></textarea>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['address'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['address'].hasError('required')" class="parsley-required">Delivery address is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="country" class="col-4 col-form-label">Country</label>
        <div class="col-8">
          <ng-select2 id="country" formControlName="country" [data]="countries" (valueChanged)="onChangeCountry($event)" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['country'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['country'].hasError('required')" class="parsley-required">Country is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="regionCode" class="col-4 col-form-label">Region</label>
        <div class="col-8">
          <ng-select2 id="region" formControlName="region" [data]="regions" (valueChanged)="onChangeRegion($event)" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['region'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['region'].hasError('required')" class="parsley-required">Region is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="city" class="col-4 col-form-label">City</label>
        <div class="col-8">
          <ng-select [items]="areas"
                     [virtualScroll]="true"
                     [loading]="loading"
                     bindLabel="Area"
                     placeholder="Select City"
                     appendTo="body"
                     [(ngModel)]="selectedArea"
                     name="city"
                     (ngModelChange)="onChangeCity(selectedArea)"
                     (scroll)="onScroll($event)"
                     (scrollToEnd)="onScrollToEnd()"
                     formControlName="city">
            <ng-template ng-header-tmp>
              <small class="form-text text-muted">Loaded {{areaBuffer.length}} of {{areas.length}}</small>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <span>{{item.Area}} - {{item.Suburb}} (<span><b>{{item.StrCode}}</b></span><span *ngIf="item.StrCode == null"><b>{{item.BoxCode}}</b></span>)</span>
            </ng-template>
          </ng-select>
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['city'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.TerminalFormGroup.controls['city'].hasError('required')" class="parsley-required">City is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="postalServiceCode" class="col-4 col-form-label">Postal Service Code</label>
        <div class="col-8">
          <input formControlName="postalcode" id="postalcode" class="form-control" maxlength="4" placeholder="Postal code">
          <ul *ngIf="submitted || this.TerminalFormGroup.controls['postalcode'].touched" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['postalcode'].hasError('required')" class="parsley-required">Postal code is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-12">
          <input formControlName="bulkOrder" style="display:inline; width:10%;" type="checkbox" id="bulkOrder" placeholder="Bulk order" (change)="onBulkOrderChange($event)" /><b>Bulk ordering </b> <br /><i>Please note that all terminals will be configured with the same settings and shipped to the same address.</i>
        </div>
      </div>

      <div class="form-group row" *ngIf="isbulkOrder">
        <label for="NumberOfTerminals" class="col-4 col-form-label">Number of terminals</label>
        <div class="col-8">
          <input formControlName="numberOfTerminals" id="numberOfTerminals" class="form-control" maxlength="4" placeholder="Number of terminals" (keypress)="restrictNumeric($event)">
          <ul *ngIf="submitted" class="parsley-errors-list filled">
            <li *ngIf="TerminalFormGroup.controls['numberOfTerminals'].hasError('required')" class="parsley-required">Terminal count is required.</li>
          </ul>

        </div>
      </div>

    </div>

  </div>

  <div class="form-group mb-0 justify-content-end row" *ngIf="btnAddTerminal">
    <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="addTerminals()">
      + Add terminal
    </button>
  </div>

</div>

<div class="row" *ngIf="deviceList?.length > 0 && !isbulkOrder">
  <div class="col-12">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Terminal Id</th>
          <th>Make</th>
          <th>Model</th>
          <th>Delivey method</th>
          <th>Activate</th>
          <th>Contactless</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr scope="col" *ngFor="let s of deviceList">
          <td>{{s.terminalId}}</td>
          <td>{{s.deviceMake}}</td>
          <td>{{s.deviceModel}}</td>
          <td>{{s.deliveryMethod}}</td>
          <td>{{s.terminalActive}}</td>
          <td>{{s.contactless}}</td>
          <td>
            <button type="button"
                    class="btn btn-info waves-effect waves-light  fa-pull-right  mx-1"
                    (click)="viewContacts(s.terminalId)">
              View more <i class="mdi mdi-information"></i>
            </button>

            <button type="button"
                    class="btn btn-danger waves-effect waves-light fa-pull-right mx-1"
                    (click)="deleteRow(s.terminalId)">
              Delete <i class="mdi mdi-delete"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="row" *ngIf="isbulkOrder">
  <div class="col-12">
    <br />
    <table class="table table-striped" *ngIf="deviceList.length > 0">
      <tbody>
        <tr class="border">
          <td colspan="9"><p class="text-success"><b>{{bulkOrderConfirmation}}</b></p></td>
          <td colspan="3">
            <button *ngIf="deviceList.length > 0" type="button"
                    class="btn btn-info waves-effect waves-light  fa-pull-right  mx-1"
                    (click)="viewbulkOrders()">
              View more <i class="mdi mdi-information"></i>
            </button>
            <button *ngIf="deviceList.length > 0" type="button"
                    class="btn btn-danger waves-effect waves-light fa-pull-right mx-1"
                    (click)="deleteAllRow()">
              Delete <i class="mdi mdi-delete"></i>
            </button>
          </td>
        </tr>        
      </tbody>
    </table>
  </div>
</div>
